<template>
	<section class="contact">
		<div class="container">
			<h2 class="contact__headline">{{ $t("home.contact.headline") }}</h2>
			<div class="row">

				<div class="hidden-sm offset-2 col-2">
					<h3 class="contact__sections">{{ $t("home.contact.events.headline") }}</h3>
					<a @click="directTo()" class="contact__events">{{ $t("home.contact.events.all") }}</a>
					<a @click="directTo('club')" class="contact__events">{{ $t("events.rank.club") }}</a>
					<a @click="directTo('national')" class="contact__events">{{ $t("events.rank.national") }}</a>
					<a @click="directTo('international')" class="contact__events">{{ $t("events.rank.international") }}</a>
				</div>
				<div class="col-sm-12 col-md-4">
					<span class="contact__mail">bestinshow@bestinshow.info</span>
					<span class="contact__tel">+48 22 398 80 10</span>
				</div>
				<div class="col-sm-12 col-md-2">
					<h3 class="contact__sections">{{ $t("home.contact.socials") }}</h3>
					<div class="contact__icons-wrapper">
						<a href=""><div class="contact__icon contact__icon--facebook"></div></a>
						<a href=""><div class="contact__icon contact__icon--instagram"></div></a>
					</div>
				</div>

			</div>
		</div>
	</section>
</template>

<script>
	export default {
		data () {
			return {
			}
		},
		methods: {
			directTo (rank) {
				this.$store.commit('clearEventsFilters')
				this.$router.push({name: 'EventsList', query: { rank }})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../styles/variables";

	.contact {
		padding: 65px 0 115px 0;
		background-color: $brown;
		&__headline {
			text-align: center;
			margin: 0;
			font-family: $libre-bold;
			font-size: 64px;
			color: $black;
			letter-spacing: 0.05em;
		}
		&__sections {
			text-align: center;
			margin: 0;
			margin-bottom: 10px;
			font-family: $libre-bold;
			font-size: 19px;
		}
		&__events {
			cursor: pointer;
			display: block;
			text-align: center;
			text-decoration: none;
			color: $black;
			font-size: 14px;
			line-height: 19px;
			margin-bottom: 2px;
		}
		&__mail {
			display: block;
			font-size: 16px;
			line-height: 30px;
			letter-spacing: 0.025em;
			margin-top: 28px;
		}
		&__tel {
			display: block;
			font-size: 16px;
			line-height: 30px;
			letter-spacing: 0.025em;
		}
		&__icons-wrapper {
			display: flex;
			justify-content: center;
		}
		&__icon {
			margin: 0 7px;
			width: 23px;
			height: 23px;
			background-position: center;
			background-size: cover;
			background-repeat: no-repeat;
			&--facebook {
				background-image: url(/static/img/facebook-app-logo.svg);
			}
			&--instagram {
				background-image: url(/static/img/instagram-social-network-logo-of-photo-camera.svg);
			}
		}
	}

	// Extra small devices (portrait phones, less than 576px)
	@media (max-width: 575.98px) {
		.contact {
			padding: 50px 0 45px 0;
			&__headline {
				font-size: 27px;
				margin-bottom: 15px;
			}
			&__mail {
				font-size: 14px;
				margin-top: 0;
				line-height: 19px;
			}
			&__tel {
				font-size: 14px;
				line-height: 19px;
				margin-bottom: 30px;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/ContactComponent.vue